import { RegraDistribuicao } from './RegraDistribuicao';
import { RegraAssociacao, RegraAssociacaoAntiga } from './RegraAssociacao';
import { TipoMinuta } from './TipoMinuta';

export class ConfiguracaoControleGabinete {

    static criar(partial: Partial<ConfiguracaoControleGabinete>) {
        const config = new ConfiguracaoControleGabinete();
        return Object.assign(config, partial);
    }

    private constructor() {
    }

    cor?: string;

    regrasDistribuicao: Array<RegraDistribuicao> = [];
    regrasAssociacao: RegraAssociacao[] = [];

    get regrasPossuiMinuta() {
        return this.regrasAssociacao.filter(regra => {
            return regra.tipoRegra.id === 'POSSUI_MINUTA';
        });
    }

    possuiRegrasPossuiMinutaComTipo(tipoMinuta: TipoMinuta) {
        return this.regrasAssociacao.filter(regra => {
            return regra.tipoRegra.id === 'POSSUI_MINUTA' && regra.valor != undefined && String(regra.valor).includes(tipoMinuta?.toString());
        }).length > 0;
    }

    possuiRegrasPossuiMinutaComQualquerTipo() {
        return this.regrasAssociacao.filter(regra => {
            return regra.tipoRegra.id === 'POSSUI_MINUTA';
        }).length > 0;
    }
}
